import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Card } from "reactstrap";
import { Container, Row, Col, Button } from "reactstrap";
import "./style.css";
import handleValidation from "../../Validation";

// checked and modified css

class Events extends Component {
  state = {
    email: "",
    errors: {},
    errorsdiv: false
  };

  submitDetails = event => {
    debugger;

    let formData = {
      email: this.refs.email.value
    };
    let errors = handleValidation(formData);
    this.setState({ errors: errors });
    if (errors["valid"] == true) {
      document.getElementById("aboutUs").action =
        "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8";
      document.getElementById("aboutUs").method = "POST";
    } else {
      this.setState({ errorsdiv: true });
      event.preventDefault();
    }
  };

  render() {
    return (
      <div className="section-padding">
        <Container>
          <Row>
            <Col sm={{ size: 12 }}>
              <h1 className="all-headers mt-5 mb-3 text-center">
                {" "}
                Upcoming Events{" "}
              </h1>
              <hr className="heading-underline mb-5" />
            </Col>
          </Row>

          <Row className="align-items-stretch justify-content-center">
            {/* <Col
              sm={{ size: 6 }}
              className="margin-between-cards d-flex align-items-stretch"
            >
                    <Card className="events-card">
                <div className="position-relative ">
                  <h2 className="event-name thin-yellow-line2  ">
                    Intro To HTML & CSS | SEO Success Factors
                  </h2>
                </div>

                <div className="left-align pt-3">
                  <div className="events-content">
                    <p className="event-time event  ">Novemeber 7, 2019</p>
                    <p className="event-time event  ">7:00pm - 9:00pm</p>
                    <p className="event-location">Atlanta, GA</p>
                    <p className="event-description">
                      Get to know us at Lighthouse and find out how we can help
                      you in your career development.
                    </p>
                  </div>
                </div>
                <a
                  href="https://www.eventbrite.com/e/intro-to-html-css-search-engine-success-factors-tickets-79161747919?aff=ebdssbdestsearch"
                  target="_blank"
                >
                  {" "}
                  <Button className="acad-btn rsvp">Attend</Button>
                </a>
              </Card>
            </Col> */}
            <Col
              sm={{ size: 6 }}
              className="margin-between-cards d-flex align-items-stretch"
            >
              <Card className="events-card">
                <div className="position-relative ">
                  <h2 className="event-name thin-yellow-line2  ">
                  Becoming A Data Scientist Info Session
                  </h2>
                </div>

                <div className="left-align pt-3">
                  <div className="events-content">
                    <p className="event-time event  ">Novemeber 12, 2019</p>
                    <p className="event-time event  ">6:30pm - 7:30pm</p>
                    <p className="event-location">Atlanta, GA</p>
                    <p className="event-description">
                      Get to know us at Lighthouse and find out how we can help
                      you in your career development.
                    </p>
                  </div>
                </div>
                <a
                  href="https://www.eventbrite.com/e/lighthouse-becoming-a-data-scientist-info-session-tickets-79212070435"
                  target="_blank"
                >
                  {" "}
                  <Button className="acad-btn rsvp">Attend</Button>
                </a>
              </Card>
            </Col>
          </Row>

          <Row className="justify-content-center mb-lg-2">
            <h3 className="mb-lg-2 mt-5">
              Sign Up For Our Newsletter For Event Updates And More!
            </h3>
          </Row>
          <form
            id="aboutUs"
            action=""
            method=""
            onSubmit={this.submitDetails.bind(this)}
          >
            <input type="hidden" name="lead_source" value="Website" />
            <input type="hidden" name="oid" value="00D3i000000GUvA" />
            <input type="hidden" name="00N3i00000Bm5C9" value="event1_signup" />
            <input
              type="hidden"
              name="retURL"
              value="https://www.atlighthouse.com/thank-you"
            />

            <Row className="justify-content-center">
              <Col lg={{ size: 4 }}>
                <label htmlFor="email" className="apply-now-labels">
                  Email<p className="required-symbol">{"*"}</p>
                </label>
                <input
                  id="email"
                  maxLength="80"
                  name="email"
                  size="20"
                  type="email"
                  className="apply-now-inputs form-control"
                  ref="email"
                  placeholder="Email"
                />
                {this.state.errorsdiv === true ? (
                  <span className="error">{this.state.errors["email"]}</span>
                ) : (
                  ""
                )}
                <br />
              </Col>
       
              <input
                type="submit"
                name="submit"
                className="btn-secondary newsletter-btn"
              />
         
            </Row>
          </form>
        </Container>
      </div>
    );
  }
}

export default Events;
